import { useEffect, useState } from 'react';

/**
 * A timestamp that refreshes every `intervalMs`, for selectors with a lastSeen-freshness window so they
 * re-evaluate over time even with no new redux update — e.g. flipping a connection indicator to
 * 'disconnected' once the heartbeat goes stale. Pass the returned value as the selector's `now` arg.
 */
export function useNowTick(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
